import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { InputItem, Card, Button, WhiteSpace, Toast, Modal  } from 'antd-mobile'
import { FixedSizeList as List } from 'react-window';
import * as Api from "../../../api/usms";
import ChannelFilter from '../components/ChannelFilter';
import { Purpose } from '../utils/const';
import { JSONParse } from '../utils/common'
const SelectPurpose = { ...Purpose };
delete SelectPurpose.All;

const alert = Modal.alert;

function BatchReplace(props){

    const { newChannel, channelReplace, companyChecked, replaceCompanyList, callback } = props

    const [ReplaceChannelId, setReplaceChannelId] = useState("")
    const [reviewLoading, setReviewLoading] = useState(false)
    const [replaceLoading, setReplaceLoading] = useState(false)
    const [replaceList, setReplaceList] = useState([])
    const [disabled, setDisabled] = useState(true)

    useEffect(() => {
      setReplaceList([])
    }, [companyChecked])

    const checkParams = (newChannel, companyChecked, ReplaceChannelId) => {
      let result = false
      if(!newChannel){
        Toast.fail("请选择原通道", 2, null, false)
      }else if(!ReplaceChannelId){
        Toast.fail("请选择要替换的通道", 2, null, false)
      }else if(!companyChecked || companyChecked.length===0){
        Toast.fail("请选择要替换渠道的公司", 2, null, false)
      }else {
        result = true
      }
      return result
    }

    const handleReplace = () => {
      if(!checkParams(newChannel, companyChecked, ReplaceChannelId)) return
      setReplaceLoading(true)
      const data = {
        ChannelId: newChannel,
        ChannelType: [channelReplace],
        Id: companyChecked,
        ReplaceChannelId
      }
      Api.ReplaceChannelControl(data).then(res => {
        if(res.RetCode!==0){
          Toast.fail(res.Message||"替换失败", 2, null, false);
        }else{
          callback()
          Toast.success("操作成功", 2, null, false);
        }
        setReplaceLoading(false)
      }).catch(e => {
        setReplaceLoading(false)
        Toast.fail(e.message || "替换异常，请联系开发")
      })
    }
    
    const handleReplaceReview = () => {
      if(!checkParams(newChannel, companyChecked, ReplaceChannelId)) return
      setReviewLoading(true)
      const data = {
        ChannelId: newChannel,
        ChannelType: [channelReplace],
        Id: companyChecked,
        ReplaceChannelId
      }
      Api.ReplaceChannelControlReview(data).then(res => {
        if (res.RetCode !== 0) {
          Toast.fail(res.Message||"预览失败", 4, null, false);
        }else{
          setReplaceList(res.Data||[])
          setDisabled(false)
        }
        setReviewLoading(false)
      }).catch(e => {
        setReviewLoading(false)
        Toast.fail(e.message||"预览失败", 4, null, false);
      })
    }
    
    const CurrentChannelType = useMemo(() => channelReplace==="Main"? 0 : 1, [channelReplace])

    const replaceCompany = useCallback(() => {
      let data = []
      if(replaceList.length){
        data = replaceList
      }else if(replaceCompanyList.length === companyChecked.length){
        data = replaceCompanyList
      }else{
        data = replaceCompanyList.filter(item => companyChecked.includes(item.Id))
      }
      if(data && data.length){
        return data.map(item => {
          const channelOld = (JSONParse(item.ChannelWeight) || [])
          .filter(item => item.Channel === newChannel && item.Type === CurrentChannelType)
          .sort((a, b) => b.Weight - a.Weight)
          let channelNew = []
          if(item.ReplaceChannelWeight){
            channelNew = (JSONParse(item.ReplaceChannelWeight)||[]).filter(item => item.Channel === ReplaceChannelId && item.Type === CurrentChannelType).sort((a, b) => b.Weight - a.Weight)
          }
          return {
            ...item,
            ChannelWeightTran: channelOld.slice(0, 1),
            ReplaceChannelWeightTran: channelNew.slice(0, 1)
          }
        })
      }
      return data
    }, [companyChecked, replaceCompanyList, replaceList])

    const CompanyList = useMemo(() => replaceCompany())

    const renderChannel = (data) => {
      return <div>
        {data.map((item,index) => {
            return <div key={index}>
              {`${item.Channel} / ${item.Weight}`}({item.Type===0?"主":"备"})
            </div>
        })}
      </div>
    }

    const renderItem = ({index, style}) =>{
      const company = CompanyList[index]
      return <div style={{...style, marginTop: "10px"}} key={company.Id}>
        <Card>
            <Card.Header
              title={`${company.CompanyName || '无公司名称'}(${company.Id || '-'})`}
            />
            <Card.Body style={{fontSize: "13px"}}>
                <div>Id/协议/短信类型/当前项目信息:</div>
                <div className="ellipsis">
                    {company.ProtoType || '-'}{` / `}
                    {SelectPurpose[company.Purpose] || '-'}{` / `}
                    {`${company.OrganizationName || '-'}-(${company.OrganizationId || '-'})-(${company.OrganizationAlias || '-'})`}
                </div>
                <WhiteSpace />
                <div style={{color: '#108ee9'}}>替换前通道占比</div>
                {renderChannel(company.ChannelWeightTran)}
                <WhiteSpace />
                <div style={{color: '#ff4d4f'}}>替换后通道占比</div>
                {company.ReplaceChannelWeightTran.length ? renderChannel(company.ReplaceChannelWeightTran):null}
            </Card.Body>
        </Card>
      </div>
    }

    return <>
        <div>
            <div style={{margin: '20px 0'}}>
                <InputItem
                  disabled
                  value={newChannel||"未选择要替换的通道"}
                >原通道
                </InputItem>
              </div>
              <div>
                 <div style={{ margin: '20px 0' }}>
                  <ChannelFilter
                    value={[ReplaceChannelId]}
                    onChange={val => {
                      if (val && val.length > 0) {
                        setDisabled(true)
                        setReplaceChannelId(val[0])
                      }
                    }}
                  /></div>
              </div>
              {CompanyList.length ? <List
                width='100%'
                height={300}
                itemCount={CompanyList.length}
                itemSize={220} 
              >{renderItem}</List>:null}
              <WhiteSpace />
              <WhiteSpace />
              <div>
                <Button type="primary" loading={reviewLoading} onClick={() => handleReplaceReview()}>预览</Button>
                <WhiteSpace />
                <WhiteSpace />
                <Button 
                    type="warning" 
                    disabled={disabled} 
                    loading={replaceLoading} 
                    onClick={() =>
                        alert('高危操作', '确定批量替换通道？', [
                          { text: '取消', onPress: () => { 
                            setDisabled(true)
                            Toast.fail("已取消", 4, null, false)} 
                          },
                          { text: '确认', onPress: () => handleReplace() },
                        ])
                      }
                >替换</Button>
              </div>
            </div>
    </>
}
export default React.memo(BatchReplace)